// this map is simply a cached list of SOLACE rewards owed
// to early farm participants on mainnet, please do not edit

export const earlyFarmRewards: { [key: string]: string } = {
  ['0x97de953cde13fd813ac6bf8e3ad8735cc18a74b7']: '7675687405402819002226',
  ['0x71ad3b3bac0ab729fe8961512c6d430f34a36a34']: '34385632809064924907799',
  ['0xe5d8eb1d907e1554dd69d05536e056b90ae43d7b']: '6496963269197570400000',
  ['0x4f6798d42feb2a9169f4fbe0f986d005e1b76180']: '32836053970730210821259',
  ['0x68b53aa18d1b8437b7cd9524040c776e2261e06d']: '27152958603292322433601',
  ['0xf8fe281a44def550c620882364e4a00f2ea80218']: '2749429922319856042662',
  ['0x091b922f4ec3c7bf73b4c484428a9d9679f8c53f']: '172750865894768138218011',
  ['0xc3422497f17a60d06a10f049c65a1dfd2b3b31be']: '159690208062628513602617',
  ['0xfb5caae76af8d3ce730f3d62c6442744853d43ef']: '333747463007872204105',
  ['0xb6c9a522a303bf3f3988fd8e3efc2383060f4cc6']: '36539366935335602442949',
  ['0xdaca78193e7e5bb52221aef14d61ead2cae27fb6']: '686189903749624844042',
  ['0x0f763341b448bb0f02370f4037fe4a2c84c9283f']: '97533482815998592650363',
  ['0x215a3749879e0ab83343d81aa670c45107a02620']: '8429692324309633965626',
  ['0x216d5609afb295931b47b7ececc36e3fc1908262']: '21479532826702884015546',
  ['0xf04de0999c16d51f8c79bdc9dd6a25eb90a94a8f']: '50817311252426905806300',
  ['0xde0639aa8a85cc9ea40f53f2dc2ad3f0d791b69c']: '7844842696480100272344',
  ['0xfa088e1f6691a4de186b6486a3266687019cf916']: '57960133147496040810722',
  ['0x7d77fbd7b12887f9ba83110b721905efa3707223']: '81950982011184924195550',
  ['0x02f98c63e6352c06fa8d5f14c004926f165cee74']: '67871065128266133308704',
  ['0x3fcab7343a2ccbc463200d7b19ea8c5e5766a676']: '20938540462325863530948',
  ['0x3da9d70305b83db1f545a5d50b19208b93cd0c21']: '204177102758622198903655',
  ['0xa9f078b3b6dd6c04308f19def394b6d5a1b8b732']: '7826281247571345431932',
  ['0x4bdf6d1dfc9993183dee1c95822a5511a234241d']: '36077386032566762558902',
  ['0x31b9084568783fd9d47c733f3799567379015e6d']: '699406851638543975368',
  ['0xa752eea12f7ecaa7674363255e5e7f0b083a515c']: '3382804151452800105949',
  ['0x283e8531d354d1296de7591018d7fb8aaefb1dd2']: '23001861108534935862353',
  ['0x17466b61cffebe6670853c68e694e0897779e19d']: '135183424565492721923',
  ['0xb0d6ae7784a9f20c1e34218998f0fc5c24972441']: '45852586260776118207379',
  ['0xcffe08bdf20918007f8ab268c32f8756494fc8d8']: '16161212673661732500000',
  ['0xba6a5d1d74e056fb7ec1263a110f5bd9462df58a']: '27394157235563301119',
  ['0x874cc5222207858c4ee336386ed32d5b04293d22']: '503437663627554060133',
  ['0xeaa4f3773f57af1d4c7130e07cde48050245511b']: '9073511974039882463831',
  ['0xfb6676656a4b6eade2c9a9f18c8cb71411e37289']: '24794467568450020839',
  ['0xd5236cca5bae6e09d044ade099397ebc30f52131']: '45833976110413979227',
  ['0xe73deef8189dd8f8f9d82229ab31f0aae8f4c875']: '335717907863639413279',
  ['0x2759b5efe48015bfbb9b0ed8bedcf62bb991ff4b']: '1174266287797313502873',
  ['0x55a6514978e8f72691454617ad187065f729d07e']: '2205347690481038448187',
  ['0xbbde1e05d96c5c4f7e377d5eaed21cac08a92945']: '18250555870639618930644',
  ['0x646e115e018766ec6a272ae5fe738c38b7f43521']: '746809583283002000000',
  ['0xf0bdfd6899389449aa77cefbed28891b12d19880']: '8073031208533889717073',
  ['0x95f6b040a013d89883e36545df53844dbda4d8d1']: '43909541591279127740343',
  ['0x5eb67a3b141f3036899ee77822a41277166c540e']: '10164210959991559205886',
  ['0x36463b59b1b8f0cc1a94054425a2b2b3a17c6901']: '138015438437044318984605',
  ['0x53646c6c68e5b99168cbbf7470e47e89897a8273']: '3404418233632609000000',
  ['0xdfab977372a039e78839687b8c359465f0f17532']: '5770038682169763515184',
  ['0x8adace41ec579423f149d7402f282301fcfaff36']: '7345788584407296815251',
  ['0xfb306239c89d9b6e6a9ab080070a68bb08cbaaa2']: '73447497559340193365876',
  ['0xafe13742864bfa0a1950bfd1200dd27da4485d94']: '7530370565237520595112',
  ['0x0d7b281fbfd3281f7859e55ff579f5ebb41e2fcb']: '2534368354850539047335',
  ['0xa2490947b30258b522b7d6fd8fabec2d21c42d57']: '16768346721556244694663',
  ['0xedd88ca63d7c0b9cf182afdee3852258f31961f9']: '266770802457954240756827',
  ['0x653a480ce4887a9081397abe77caf6221b3d4f4c']: '1348321976747555729081408',
  ['0xef9f32bf7c6381d42bb942832fd0e56ab99008fb']: '750975889096637186614',
  ['0xd8faec528b9fbf4fe3226d6beb8b14a4f9bad655']: '17938772189360896000000',
  ['0x3194770e03ec3b0ebeaa7eb93b01290a85acc905']: '1532490805411938583990',
  ['0xe62c522b0eea657414fad0a1893223f54ccd5190']: '2449214728316122540132',
  ['0xcf3a24407aae7c87bd800c47928c5f20cd4764d2']: '54542901295883322357650',
  ['0xce66c6a88bd7bec215aa04fda4cf7c81055521d0']: '9177428764843737000000',
  ['0xdd6fd6622d4af631d8c5c1f637526e89ccff9646']: '7162453149492856555588',
  ['0x70e439584ef1ba300106b9c16543eaa1de676dc2']: '16769233450290000243488',
  ['0x8501518fe7d26c416d63072847c59d454103db4b']: '183431674385517118199876',
  ['0x8829f99344bca59d5c7ccb36848fe7efd2efb4eb']: '1724782436361294770596',
  ['0xe859f96c7a5a25c74dc7bb1f8ac2af2ea3a6160f']: '1965984190799191000000',
  ['0x4a86e7efce5f37583e6b7c4db88d37eff5812685']: '3609725332985880964326',
  ['0x0025befed0d57a11db1dc26a80e651bb38c97027']: '8854975101309064622989',
  ['0xdd13eb27af410ea094c2ac357f1b79b62f738062']: '4469987861152157179400',
  ['0x7c224beeb6064d7ca376dc66a8d1245ad5926aa6']: '18211902270426337853688',
  ['0x5bcf75ff702e90c889ae5c41ee25af364abc77cb']: '32615118336925539972637',
  ['0x195f61d13576f2ec92c812dc01faafd6433b6af7']: '10559325358037823770867',
  ['0x773cfc636f996f8bb0334c60fbb67ceb4154a6c2']: '800693604646445514408',
  ['0x5edd81949604c74e984ee3424a72c6733df463d3']: '1027094094836241999411',
  ['0x404d846c95b2a70104fbae9797305beaa27a4062']: '22317680793320406444413',
  ['0x167d6fb10d4e6f037e97d4d9879f96b0b36023d1']: '2239099505396122123790',
  ['0x75352403b0355bf8c7b92bbd27fbe09d25f099c4']: '118919060569589003433829',
  ['0xf71e9c766cdf169edfbe2749490943c1dc6b8a55']: '18991827249241032500375',
  ['0xa72dd12b9329e6efe095c030f361131604a79586']: '1816662485303228700503',
  ['0xeda6b8db5517b1b55d3c99dfed9b671a143f8d05']: '2601481543929310777990',
  ['0x1750e7dfdd32fe6205e900b9cfb6c2247af8095f']: '6090504983262995964220',
  ['0x63c87453ad6ac61754092780713d96bc57d16288']: '1093996702916578321459',
  ['0x56ddd887fd2ed44c73d51f4127ab00ba3efc6527']: '9552340712837820629535',
  ['0x2808edd543813fcf418de85bb42eedf3b39ba72c']: '7692901473596712470064',
  ['0x10b0a72ea6110a4b985e21f62c4e30d09ccec89c']: '2600800077532542896844',
  ['0xe3bf79e595a4be7b0dc9d60b32dea80ab7ee5d17']: '3970313504049293874173',
  ['0x942b04e62bd86b1e273f3df3e52b7a980b5f07ba']: '9116144367894756394603',
  ['0x7894684edfdaa6113cf416e84cdb826a41ef45b8']: '4300081103174458550000',
  ['0x9893360c45ef5a51c3b38dcbdfe0039c80fd6f60']: '162722383938897259735501',
  ['0x8707cde20dd43e3db1f74c28fcd509ef38b0ba51']: '32924386832511512000000',
  ['0x529813a65f05a6c479db8d7443739448463a9d1c']: '28930851333353686202899',
  ['0x45c791d8fe882f36c38edae92ef048f8a736c805']: '9494402769183412000000',
  ['0x70f8d86ac14548ce33da8a3fcd19076c56e0ea9d']: '2303160410218429144754',
  ['0x6d5fa92e25721aa23071ea6a8df9cee67c5820b3']: '600140166955227161918',
  ['0x9d156bc7c8768294510a4a41883d5a4eb15b15e3']: '6214544701762060903716',
  ['0x8ac9db9c51e0d077a2fa432868eafd02d9142d53']: '7564090119497999264632',
  ['0x049aa75e6ab5e2ab2ae21ddab95252ab76ec800a']: '61969664211437388650887',
  ['0x31bfb5c4ee08ba9f65582f3e5ff215cccfa3f860']: '87259984939482737621073',
  ['0xa841b95d61171a55ca5bfaf99da5b19e2d5b710f']: '3040550512263936432773',
  ['0xc724f1558eb9216bb9e04be169317f70dcbef857']: '34005364213560633755358',
}
